import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-heyjom-layout',
    templateUrl: './heyjom-layout.component.html',
    styleUrls: ['./heyjom-layout.component.scss']
})
export class HeyjomLayoutComponent implements OnInit {

    constructor() { }

    ngOnInit(): void {
    }

}
